import { Button } from "@material-ui/core";
import React from "react";

const BackButton = (props) => (
  <Button {...props} variant={props.variant || "outlined"} color={props.color || "default"} />
);

export default BackButton;
